import React from 'react'
import PropTypes from 'prop-types'
import MUIDataTable from 'mui-datatables'
import { ThemeProvider } from '@mui/material/styles'
import { Paper, Typography, Box } from '@mui/material'

import { getMuiTheme } from '../../../utils'

const DataTableComponent = ({ md = 12, data, columns, options, hidden, title }) => (
  <div
    className={`col-xl-${md} col-md-${md} col-sm-${md} `}
    hidden={hidden}
  >
    <Box
      component={Paper}
      elevation={6}
      className="rounded-2xl shadow-md overflow-hidden"
    >
      <ThemeProvider theme={getMuiTheme()}>
        <MUIDataTable
          title={title}
          data={data}
          columns={columns}
          options={options}
        />
      </ThemeProvider>
    </Box>
  </div>
)

DataTableComponent.propTypes = {
  md: PropTypes.number,
  title: PropTypes.string,
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  options: PropTypes.object.isRequired,
  hidden: PropTypes.bool,
}

export default DataTableComponent
